import gql from 'graphql-tag';
import { MatchListingFragment } from './MatchListingFragment';
import { findMatch as MatchListingQueryType, findMatchVariables } from 'src/schema';
import { Query } from 'react-apollo';

export const MatchListingQueryGql = gql`
  query findMatch($input: FindMatchInput!) {
    findMatch(input: $input) {
      ...MatchListing
    }
  }
  ${MatchListingFragment}
`;

export class MatchListingQuery extends Query<MatchListingQueryType, findMatchVariables> {}



// WEBPACK FOOTER //
// ./src/pages/MatchPage/Queries/MatchListingQuery.ts